import React, { memo } from "react";
import styles from "./SearchInput.module.scss";
import SearchIcon from "@/components/SVGComponents/SearchIcon";
import CrossIcon from "@/components/SVGComponents/CrossIcon";
import { combineClasses } from "@/lib/utils";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onClear,
  placeholder = "Search...",
  className,
}) => {
  return (
    <div className={combineClasses(styles.searchContainer, className)}>
      <SearchIcon className={styles.searchIcon} />

      <input
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        placeholder={placeholder}
        className={styles.searchInput}
      />

      {value && (
        <CrossIcon
          height="18"
          onClick={onClear}
          className={styles.clearIcon}
        />
      )}
    </div>
  );
};

export default memo(SearchInput);